import mergeConfig from 'coact/config/mergeConfig'

import Invoice from '~/src/invoice/printer/Invoice.jsx'

import TestInvoicePage from './TestInvoicePage.jsx'
// const UploadInvoiceRange = require('./selfChecker/UploadInvoiceRange').default
// const InvoiceDailyReport = require('./selfChecker/InvoiceDailyReport').default

// TODO move printers to view, require('twInvoice/Invoice')
const config = {
  printers: {
    'retailOrders:cashier': Invoice,
    'retailOrders:eventCashier': Invoice,
    'salesOrders:main': Invoice,
    'recStatements:main': Invoice,
    'invoices:issuer': Invoice,
  },
  routes: {
    testInvoicePrinter: {
      title: '電子發票印表機測試',
      path: '/route/testInvoicePrinter',
      component: TestInvoicePage,
    },
  },
  // routes: {
  //   uploadInvoiceRange: {
  //     title: '上傳發票字軌號碼',
  //     path: '/route/uploadInvoiceRange',
  //     component: UploadInvoiceRange,
  //   },
  //   invoiceDailyReport: {
  //     title: '發票日報表',
  //     path: '/route/invoiceDailyReport',
  //     component: InvoiceDailyReport,
  //   },
  // },
}

export default fullConfig => mergeConfig(fullConfig, config)
